import {cookieStore} from 'libs/storage/storage';
import {HTO_COOKIE_FOR_LANDING_URL} from 'constants/cookie';

/**
 * getLandingUrl function which return current HTO_COOKIE_FOR_LANDING_URL cookie and optional set it
 * @returns {string} HTO_COOKIE_FOR_LANDING_URL cookie
 */
const getLandingUrl = () => {
    let landingUrlCookie = cookieStore.get(HTO_COOKIE_FOR_LANDING_URL);
    if (!landingUrlCookie) {
        landingUrlCookie = `${window.location.pathname}${window.location.search}`;
        cookieStore.set(HTO_COOKIE_FOR_LANDING_URL, landingUrlCookie);
    }
    return landingUrlCookie;
};

export default getLandingUrl;
